import React, { useState } from 'react';

import { AccessInfo, CardControlLoader, CardRule, Piwik, SiteCoreDictionary } from '../types';
import FormBlockedInfo from './form-blocked-info/FormBlockedInfo';
import Header from './header/Header';
import InfoModal from './infoModal/InfoModal';
import ToggleList from './toggleList/ToggleList';

interface RegionsProps {
    cardControlLoader: CardControlLoader;
    cardRule: CardRule;
    handleRegionRuleChange: (regionId: string, enabled: boolean) => void;
    accessInfo: AccessInfo;
    dictionary: SiteCoreDictionary;
    piwik: Piwik | undefined;
}

export default (props: RegionsProps) => {
    const [showModal, setShowModal] = useState<boolean>(false);

    const { piwik, dictionary, accessInfo, cardRule } = props;

    return (
        <>
            <section
                className="block-category"
                data-track-id={piwik?.regionBlockEcommerce?.regionBlockForm?.dataTrackId}
                data-track-linkname={piwik?.regionBlockEcommerce?.regionBlockForm?.dataTrackLinkname}
                id={piwik?.regionBlockEcommerce?.regionBlockForm?.dataTrackId}
            >
                <Header setShowModal={setShowModal} dictionary={dictionary} />

                <FormBlockedInfo accessInfo={accessInfo} dictionary={dictionary} piwik={piwik} />

                <ToggleList
                    {...props}
                    data-track-id={piwik?.regionBlockEcommerce?.regionBlockToggleList?.dataTrackId}
                    data-track-linkname={piwik?.regionBlockEcommerce?.regionBlockToggleList?.dataTrackLinkname}
                    dictionary={dictionary}
                    piwik={piwik}
                />
            </section>

            <InfoModal
                dictionary={dictionary}
                showModal={showModal}
                setShowModal={setShowModal}
                regions={cardRule.regions}
            />
        </>
    );
};
